// Builds an EngineInput from decoded data-layer pieces. Shared by the app and the golden test,
// so the test exercises the same decode path as the browser.

import type { EngineInput, Ring } from '../engine/types';

export interface DsmWindow { data: Uint16Array; width: number; height: number; originE: number; originN: number }
export interface ParcelGeom { rings: Ring[]; props: { ko: number; koName: string; st: string; area: number } }
export interface BuildingGeom { st: number; rings: Ring[]; props: Record<string, number | null> }
export interface Tmy { lat: number; lon: number; gbn: number[]; gdh: number[]; t2m: number[] }

export function assembleInput(
  dsm: DsmWindow, parcel: ParcelGeom, buildings: BuildingGeom[], farHorizon: number[], tmy: Tmy,
): EngineInput {
  if (farHorizon.length !== 49) throw new Error(`far horizon has ${farHorizon.length} values, expected 49`);
  if (tmy.gbn.length !== 8760 || tmy.gdh.length !== 8760 || tmy.t2m.length !== 8760) throw new Error('TMY must have 8760 hours');
  return {
    dsm,
    parcel,
    buildings,
    farHorizon,
    tmy: { lat: tmy.lat, lon: tmy.lon, gbn: tmy.gbn, gdh: tmy.gdh, t2m: tmy.t2m },
  };
}

/** Bytes of a little-endian uint16 raster → Uint16Array (copy, so alignment never matters). */
export function u16FromBytes(buf: ArrayBuffer | Uint8Array): Uint16Array {
  const b = buf instanceof Uint8Array ? buf : new Uint8Array(buf);
  const out = new Uint16Array(b.length >> 1);
  for (let i = 0; i < out.length; i++) out[i] = b[2 * i] | (b[2 * i + 1] << 8);
  return out;
}

/** Normalise "koName": index names may carry the id prefix ("1131 MARIJA DOBJE"). */
export function stripKoPrefix(ko: number | string, name: string): string {
  const p = `${ko} `;
  return name.startsWith(p) ? name.slice(p.length) : name;
}
